import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.5.875A8.125 8.125 0 1 0 16.625 9 8.134 8.134 0 0 0 8.5.875m3.87 6.702-4.584 4.375a.627.627 0 0 1-.864 0L4.63 9.765a.626.626 0 0 1 .865-.905l1.859 1.776 4.151-3.963a.626.626 0 0 1 .865.904"
    }, null, -1)
  ])))
}
export default { render: render }